import en from './calamansi/en.json'
import enGB from './calamansi/en-GB.json'
import enAU from './calamansi/en-AU.json'
import enIN from './calamansi/en-IN.json'
import enZA from './calamansi/en-ZA.json'
import es from './calamansi/es.json'
import esES from './calamansi/es-ES.json'
import esPH from './calamansi/es-PH.json'
import fr from './calamansi/fr.json'
import frCA from './calamansi/fr-CA.json'
import de from './calamansi/de.json'
import nl from './calamansi/nl.json'
import sv from './calamansi/sv.json'
import pt from './calamansi/pt.json'
import ptBR from './calamansi/pt-BR.json'
import af from './calamansi/af.json'
import zh from './calamansi/zh.json'
import ja from './calamansi/ja.json'
import ko from './calamansi/ko.json'
import yue from './calamansi/yue.json'
import bo from './calamansi/bo.json'
import tl from './calamansi/tl.json'
import vi from './calamansi/vi.json'
import hi from './calamansi/hi.json'
import ta from './calamansi/ta.json'
import haw from './calamansi/haw.json'
import ht from './calamansi/ht.json'
import eu from './calamansi/eu.json'
import mi from './calamansi/mi.json'
import gn from './calamansi/gn.json'
import qu from './calamansi/qu.json'
import nah from './calamansi/nah.json'
import nv from './calamansi/nv.json'
import iu from './calamansi/iu.json'
import cr from './calamansi/cr.json'
import oj from './calamansi/oj.json'
import ceb from './calamansi/ceb.json'
import ilo from './calamansi/ilo.json'
import cbk from './calamansi/cbk.json'
import ug from './calamansi/ug.json'
import arPS from './calamansi/ar-PS.json'
import zgh from './calamansi/zgh.json'
import rhg from './calamansi/rhg.json'
import crh from './calamansi/crh.json'
import eo from './calamansi/eo.json'
import pjt from './calamansi/pjt.json'
import pig from './calamansi/pig.json'
import pir from './calamansi/pir.json'
import tlh from './calamansi/tlh.json'
import val from './calamansi/val.json'
import blt from './calamansi/blt.json'
import dot from './calamansi/dot.json'
import tok from './calamansi/tok.json'
import nav from './calamansi/nav.json'
import qya from './calamansi/qya.json'
import sjn from './calamansi/sjn.json'
import hod from './calamansi/hod.json'
import dov from './calamansi/dov.json'
import nds from './calamansi/nds.json'
import nws from './calamansi/nws.json'
import mnd from './calamansi/mnd.json'
import csp from './calamansi/csp.json'
import sim from './calamansi/sim.json'
import ali from './calamansi/ali.json'

const I18N_LOCALES = {
  en,
  'en-GB': enGB, 'en-AU': enAU, 'en-IN': enIN, 'en-ZA': enZA,
  es, 'es-ES': esES, 'es-PH': esPH,
  fr, 'fr-CA': frCA,
  de, nl, sv,
  pt, 'pt-BR': ptBR,
  af,
  zh, ja, ko, yue, bo,
  tl, vi, hi, ta,
  haw, ht, eu, mi,
  gn, qu, nah, nv, iu, cr, oj,
  ceb, ilo, cbk,
  ug, 'ar-PS': arPS, zgh, rhg, crh,
  eo, pjt,
  pig, pir, tlh, val, blt, dot, tok, nav, qya, sjn, hod,
  dov, nds, nws, mnd, csp, sim, ali,
}

export default I18N_LOCALES
